import Model from '../../ModelBinding/Model';
import GuidelineCollection from './GuidelineCollection';
import dayjs from 'dayjs';
import TechnicalDetailValueCollection from '../TechnicalDetailValue/TechnicalDetailValueCollection';
import OfferCollection from '../Offer/OfferCollection';

export default class Guideline extends Model {
  public guideline_type?: string;
  public title?: string;
  public description?: string;
  public technical_details?: TechnicalDetailValueCollection;
  public offers?: OfferCollection;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.guideline_type = this.getStringAttribute('guideline_type');
    this.title = this.getStringAttribute('title');
    this.description = this.getStringAttribute('description');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.technical_details = this.getRelationCollection(
      'technical_details',
      TechnicalDetailValueCollection,
    ) as TechnicalDetailValueCollection;
    this.offers = this.getRelationCollection('offers', OfferCollection) as OfferCollection;
  }

  static getCollection() {
    return GuidelineCollection;
  }
}
